import { s__ } from '~/locale';

// Mirrors the `source` enum in the proposed storage model.
// https://gitlab.com/gitlab-org/gitlab/-/work_items/603064#note_3681023203
export const DECISION_SOURCE_MANUAL = 'MANUAL';
export const DECISION_SOURCE_DUO_FLOW = 'DUO_FLOW';
export const DECISION_SOURCE_THREAD_RESOLUTION = 'THREAD_RESOLUTION';

// Where the decision came from. Each one is a complete sentence, because the card renders it on a
// line of its own. The author named here is whoever raised the question, not whoever settled it.
export const DECISION_SOURCE_TEXTS = {
  [DECISION_SOURCE_DUO_FLOW]: s__(
    'WorkItemDecisionLog|Suggested answer to an open question raised by %{author}',
  ),
  [DECISION_SOURCE_MANUAL]: s__('WorkItemDecisionLog|Recorded manually on this work item'),
  [DECISION_SOURCE_THREAD_RESOLUTION]: s__(
    'WorkItemDecisionLog|Recorded from a thread on this work item',
  ),
};
